import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { isNullOrUndefined } from '../utils/is-null-or-undefined';

function handleZoneNaming(): void {
  // Manual override because we'll be displaying UTC +offset on
  // users where timezones are not in the Americas
  const abbrs = {
    EST: 'EST', // 'Eastern Standard Time'
    EDT: 'EDT', // 'Eastern Daylight Time'
    CST: 'CST', // 'Central Standard Time'
    CDT: 'CDT', // 'Central Daylight Time'
    MST: 'MST', // 'Mountain Standard Time'
    MDT: 'MDT', // 'Mountain Daylight Time'
    PST: 'PST', // 'Pacific Standard Time'
    PDT: 'PDT', // 'Pacific Daylight Time'
  };

  // Quick hack to make TZ work as expected, without having to add external typings
  const m: any = moment;

  m.fn.zoneName = function(): any {
    const abbr = this.zoneAbbr();

    // If user's timezone is somewhere outside the Americas,
    // return the UTC +00 offset format, if in Americas, return the abbrev format above
    const output = abbrs[abbr] || 'GMT ' + abbr;

    // This only happens when the user's timezone is in UTC/GMT + 0;
    if (output === 'GMT GMT') {
      return 'GMT';
    }

    return output;
  };
}

export function formatStandardDateTime(value: any, opts?: { showOnly: 'time' | 'date' }): string {
  // NOTE FOR opts.showOnly
  // Use this only if you need to add a hard line break between date and time
  // DO not use for anything else
  const date = moment(value);
  if (isNullOrUndefined(value) || !date.isValid()) {
    return '-';
  }

  handleZoneNaming();
  const browserTimezone = moment.tz.guess();

  if (opts && opts.showOnly === 'time') {
    return date
      .tz(browserTimezone)
      .format('hh:mm A (zz)');
  }

  if (opts && opts.showOnly === 'date') {
    return date.format('MMM DD, YYYY');
  }

  return date
    .tz(browserTimezone)
    .format('MMM DD, YYYY hh:mm A (zz)');
}

@Pipe({
  name: 'standardDateTime',
})
export class StandardDateTimePipe implements PipeTransform {
  public transform(value: any, opts?: { showOnly: 'time' | 'date' }): string {
    return formatStandardDateTime(value, opts);
  }
}
